import React from 'react'
import PropTypes from 'prop-types'

const RemoveOfferButton = ({ offerId, onRemoveOfferSuccess }) => {
  const removeOffer = (e) => {
    e.preventDefault()

    axios.post(`/api/internal/price_offers/${offerId}/withdraw`)
      .then(onRemoveOfferSuccess)
      .catch(onRemoveOfferFailure)
  }

  const onRemoveOfferFailure = () => {
    App.events.publish('app:notification:flash:error', 'Unfortunately price offer couldn\'t be withdrawn.')
  }

  return (
    <button className="button button--alt u-float-right" onClick={removeOffer}>Remove my offer</button>
  )
}

RemoveOfferButton.propTypes = {
  offerId: PropTypes.number.isRequired,
}

export default RemoveOfferButton
